import { createSlice } from '@reduxjs/toolkit';

/**
 *
 * @type RegionStoreState
 */
const initialState = {
  regionList: { loading: false, data: null, error: null }
};

export const RegionSlice = createSlice({
  name: 'region',
  initialState,
  reducers: {
    fetchRegionListRequest: (state, action) => {
      state.regionList.loading = true;
      state.regionList.error = null;
    },
    fetchRegionListSuccess: (state, action) => {
      state.regionList.data = action.payload;
      state.regionList.loading = false;
      state.regionList.error = null;
    },
    fetchRegionListFailure: (state, action) => {
      state.regionList.data = null;
      state.regionList.loading = false;
      state.regionList.error = action.payload;
    }
  }
});

export const {
  fetchRegionListRequest,
  fetchRegionListSuccess,
  fetchRegionListFailure
} = RegionSlice.actions;

/**
 *
 * @param {*} store
 * @returns {RegionStoreState['regionList']}
 */
export const getRegionListState = (store) => store.region?.regionList;

export default RegionSlice.reducer;
